<template>
  <div>
    <div class="big-title">
      <span>地区及机构</span>
    </div>
    <a-row>
      <a-row :gutter="4">
        <a-col :span="8">
          <span class="list-header">抽检区县</span>
        </a-col>
        <a-col :span="8">
          <span class="list-header">抽检数量</span>
        </a-col>
        <a-col :span="8">
          <span class="list-header">检测机构</span>
        </a-col>
      </a-row>
      <a-row v-for="task in localValue" :gutter="4" :style="{margin:'4px'}">
        <a-col :span="8">
          <div class="box">{{task.regionName}}</div>
        </a-col>
        <a-col :span="8">
          <div class="box">{{task.taskDetail[0].monitTargetCount}}</div>
        </a-col>
        <a-col :span="8">
          <a-select v-model:value="task.execDept" disabled placeholder="请选择检测机构" style="width: 100%">
            <a-select-option v-for="opt in options" :value="opt.value" :key="opt.value"> {{ opt.name }} </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="4" :style="{margin:'4px'}">
        <a-col :span="8">
        </a-col>
        <a-col :span="8">
          <div class="total-box">
            总数量：<span style="color: red">{{total}}</span>
          </div>
        </a-col>
        <a-col :span="8">
        </a-col>
      </a-row>
    </a-row>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
//TODO: 修改
import {getChildRegion as initRegion} from '../../../api/api'
//TODO: 修改
import {getRegionTree as initGov} from '../../../api/api'
export default {
    name: "index",
    mixins:[mixin],
    props:{
        region:{
            type:String,
            default:''
        },
        //sync修饰
        total:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            options:[],
            localValue: [],
            total:0
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            if(!(this.localValue&&this.localValue.length>0)){
                this.localValue=[];
                //查询所有地市
                initRegion(this.region).then(result => {
                    if (result.data && result.data.succ) {
                        let regions=result.data.data;
                        regions.forEach(item=>{
                            let task={
                                regionName: item.name,
                                regionCode: item.value,
                                taskDetail: [{
                                    targetRegionName:item.name,
                                    targetRegionCode:item.value,
                                    monitTargetCount:undefined
                                }],
                                monitTargetCount:0,
                                execDept:''
                            }
                            this.localValue.push(task);
                        })
                        let total=this.getMonitTargetCount(this.localValue);
                        this.total=total;
                    }
                }).catch(() => {
                    this.options=[];
                })
            }
            //初始化机构下拉框
            initGov("\'city\'").then(result => {
                if (result.data && result.data.succ) {
                    this.options = result.data.data;
                }
            }).catch(() => {
                this.options=[];
            })
        },
        changeTask(task)
        {
            let totalRow = this.getMonitTargetCount(task.taskDetail);
            task.monitTargetCount=totalRow;
            let total=this.getMonitTargetCount(this.localValue);
            this.$emit('update:total', total)
        },
        getMonitTargetCount(arr)
        {
            if (arr)
            {
                let i=0;
                arr.forEach(item=>{
                    i+=item.monitTaskRegionList[0].pickCount;
                })
                return i;
            }
            else {
                return 0;
            }
        }
    }

}
</script>

<style scoped>
  .box{
    min-height: 40px;
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    padding-left: 5px;
    font-weight: 700;
    color: #7c7c7c;
  }

  .total-box{
    min-height: 40px;
    font-weight: 700;
    color: #7c7c7c;
  }

  /deep/ .ant-select-selection--single{
    height: 40px;
  }

  /deep/ .ant-select{
    vertical-align: top;
  }

  /deep/ .ant-select-selection__rendered{
    line-height: 40px;
    color: #7c7c7c;
    font-weight: 700;
  }

  /deep/ .ant-input-number {
    height: 40px;
    vertical-align: top;
    width: 100%;
  }
  .list-header {
    padding-left: 20px;
    color: #888888;
    font-weight: 700;
  }

  .big-title {
    color: #444444;
    font-weight: 700;
  }
</style>